"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DeferredBatcher = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _Batcher = require("./Batcher");
class DeferredBatcher extends _Batcher.Batcher {
  constructor(network, client, listener) {
    super(network, client);
    (0, _defineProperty2.default)(this, "deferred", void 0);
    (0, _defineProperty2.default)(this, "resolve", void 0);
    (0, _defineProperty2.default)(this, "reject", void 0);
    (0, _defineProperty2.default)(this, "type", void 0);
    this.listener = listener;
  }
  async executeDeferred() {
    if (!this.deferred) {
      throw new Error("No deferred execution found.");
    }
    let batch = this.batch;
    try {
      let res = await this.client.multicall(this.chain, batch);
      let data = this.finalize(res);
      this.result(data);
    } catch (err) {
      this.error(err);
    }
  }
  finalize(result) {
    return super.finalize(result, this.type);
  }
  execute(type) {
    if (this.deferred) {
      throw new Error("Deferred execution is already present, can't execute again");
    }
    this.type = type;
    this.deferred = true;
    let promise = new Promise((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });
    this.listener();
    return promise;
  }
  result(data) {
    if (!this.resolve) {
      throw new Error("Can't set result, no resolve function found");
    }
    this.resolve(data);
    this.clean();
  }
  error(data) {
    if (!this.reject) {
      throw new Error("Can't set error, no reject function found");
    }
    this.reject(data);
    this.clean();
  }
  clean() {
    this.resolve = undefined;
    this.reject = undefined;
  }
}
exports.DeferredBatcher = DeferredBatcher;
//# sourceMappingURL=DeferredBatcher.js.map